import { useEffect, useRef } from 'react';

const SCROLL_POSITION_KEY = 'eventsListScrollPosition';

function getScrollContainer(): HTMLElement | null {
  return document.querySelector('.main-panel > .content');
}

/**
 * Saves scroll position on unmount, restores on mount when data is ready.
 */
export function useScrollRestore(isReady: boolean) {
  const hasRestoredRef = useRef(false);

  useEffect(() => () => {
    const container = getScrollContainer();
    if (container) {
      sessionStorage.setItem(SCROLL_POSITION_KEY, String(container.scrollTop));
    }
  }, []);

  useEffect(() => {
    if (!isReady || hasRestoredRef.current) return;
    hasRestoredRef.current = true;

    const container = getScrollContainer();
    if (!container) return;

    const savedPosition = sessionStorage.getItem(SCROLL_POSITION_KEY);
    if (savedPosition) {
      requestAnimationFrame(() => {
        container.scrollTop = Number(savedPosition);
      });
    }
  }, [isReady]);
}
